import { css } from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

// Misma tarjeta que los bloques de la ficha del candidato
const borderRadius = '6px';
// const boxShadow = '0px 4px 6px rgb(98 102 113 / 6%), 0px 2px 2px rgb(98 102 113 / 6%)';
const boxShadow = '0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06)';

export { borderRadius, boxShadow };


export const headerStatStyles = css`
  && {
    padding: 0;
    min-width: 200px;
    background-color: ${colors.white};
    border-radius: ${borderRadius};
    box-shadow: ${boxShadow};
  }
  
  /* Cabecera: título 14/600 sobre la línea en el color del cliente */
  .header-stat {
    border-bottom: 2px solid ${props => props.theme.primary};
    background-color: ${colors.white};
    text-align: left;
    padding: 10px 16px;
    gap: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    border-top-left-radius: ${borderRadius};
    border-top-right-radius: ${borderRadius};
    
    p {
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      color: ${tokens.color.text.primary};
      margin: 0;
      display: flex;
      align-items: center;
      gap: 6px;

      svg {
        flex-shrink: 0;
        color: ${tokens.color.text.tertiary};
      }
    }

    .RGL-widgetDeleteButton {
      flex-shrink: 0;
      padding: 4px;
      border-radius: 6px;
      color: ${tokens.color.text.tertiary};
      transition: color 0.2s ease, background-color 0.2s ease;

      :hover {
        color: ${tokens.color.error.main};
        background-color: ${tokens.color.background.light};
      }
    }
  }
`

export const noDataStyles = css`
  .no-data-available {
    background: ${colors.white};
    padding: 30px 0;
    text-align: center;
  }
`
export const chartWrapperStyles = css`
  .chart-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.white};
    padding: 30px;
    border-bottom-left-radius: ${borderRadius};
    border-bottom-right-radius: ${borderRadius};    
  }
`
